import { AnimatePresence } from 'framer-motion';
import { OurWhy } from './OurWhy';
import { OurTeam } from './OurTeam';
import { ReachOut } from './ReachOut';
import { AboutOath } from './AboutOath';
import { OurImpact } from './OurImpact';
import { Quote } from 'components/LottieElements/Quote';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';

export const AboutScreen = () => {
  return (
    <HeaderAndFooterLayout
      footerVisible={true}
      headerVisible={true}
      isLoading={false}
      hasIssues={true}
    >
      <AnimatePresence>
        <OurWhy />
        <AboutOath />
        <OurImpact />
        <OurTeam />
        <Quote
          text="“A quote from Brian or Taylor on Oath consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam”"
          name="Full Name Here"
          role="Role at Oath"
        />
        <ReachOut />
      </AnimatePresence>
    </HeaderAndFooterLayout>
  );
};
